export default "__VITE_ASSET__DgojnNAE__"